export enum EDemandPeriod {
  PEAK = "PEAK",
  OFF_PEAK = "OFF_PEAK",
  DAY = "DAY",
}
